// extracted by mini-css-extract-plugin
module.exports = {"word":"SentenceBuilderView_word__RzOdR","missing":"SentenceBuilderView_missing__3eLJk"};